import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import classNames from "classnames";
import { faXmark, faCheck } from "@fortawesome/sharp-solid-svg-icons";
import { forwardRef } from "react";

import styles from "./checkbox-indicator.module.scss";

type CheckboxIndicatorProps = {
  variant: "check" | "disabled-check" | "x";
};

const CheckboxIndicator = forwardRef<HTMLDivElement, CheckboxIndicatorProps>(
  ({ variant }, ref) => (
    <div
      ref={ref}
      className={classNames(styles.indicator, {
        [styles.check]: variant === "check",
        [styles.disabledCheck]: variant === "disabled-check",
        [styles.x]: variant === "x",
      })}
    >
      <FontAwesomeIcon icon={variant === "x" ? faXmark : faCheck} />
    </div>
  ),
);

export default CheckboxIndicator;
